module.exports = __webpack_public_path__ + "static/media/71UmaqAp8eL._AC_SL1500_.fb33fdeb.jpg";